export const environment = {
  product:'YC',
  production: true,
  isAdmin: false,
  httpBase: 'https://sqtszkj.com/api/admin',
  tenantHttpBase: 'https://sqtszkj.com/api/tenant',
  // ICON_FONT_URL: 'https://at.alicdn.com/t/font_2734856_ebi314y1bw.js',
  ICON_FONT_URL: 'https://at.alicdn.com/t/font_2734856_87ys8uh9vro.js',
  loginUrl:'https://sqtszkj.com/#/login',
};

export const httpBaseParam = {
  httpBase: environment.httpBase,
  organizationId: 1
}
